<template>
    <div>

    </div>
</template>

<script>
module.exports = {
    data() {
        return {}
    },

}
</script>

<style scoped>

</style>